module.exports = __webpack_public_path__ + "957d57ed076ad3367970c49816bef9f7.pdf";